/**
 * @generated SignedSource<<a997d919fe3381a1a5bd35866750628b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesCreator_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FollowButton_viewer">;
  readonly " $fragmentType": "DesignSeriesCreator_viewer";
};
export type DesignSeriesCreator_viewer$key = {
  readonly " $data"?: DesignSeriesCreator_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesCreator_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesCreator_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FollowButton_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e88613d7c5b1aaca20c56a9c4e6e3dbb";

export default node;
